import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            user: 'authentication/user',
        }),

        isOnFreePlan() {
            return this.user && this.user.subscription && this.user.subscription.is_free;
        },
    },
};
